import React, { Component } from "react";
import styled from "styled-components";
import "./App.css";
import Wall from "./components/Wall";

function App() {
  return (
    <div>
      <Wall />
    
    </div>
  );
}


export default App;
